import Model from "./base/model";

class transporterConfiguration extends Model {
  resourceName() {
    return "transporter_configurations";
  }

  fields() {
    return {
      notfis_email: "",
      ocoren_email: "",
      notfis_version: "",
      ocoren_version: "",
      cte_email: "",
    }
  }
}

export default new transporterConfiguration();
